module.exports = __webpack_public_path__ + "img/uk-blood-diseases-female.c2ff08e8.png";